import { bindActionCreators } from 'redux';
import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { reinstateEntry, toggleEntryReinstate, getProjectEntriesState,
  getEntry } from 'project/ducks/entries';
import { getProjectIdFromUrl } from 'project/utils';
import Confirmation from 'common/components/modal/confirmation_dialog';

export function mapStateToProps(state) {
  const userId = idx(state, _ => _.user.profile_data.id);
  const entryId = getProjectEntriesState(state).currentSelectedEntry;
  const entry = getEntry(state, entryId);

  if (!entry) {
    return {};
  }

  const isAuthor = entry.author === userId;
  const headerAction = isAuthor ? 'un-withdraw' : 'un-eliminate';

  return {
    dialogHeader: `${headerAction} Entry`,
    dialogTitle: `Are you sure you want to ${headerAction} this entry?`,
    dialogMessage: 'It will be visible again.',
    dialogVisible: idx(state, _ => _.project.projectPage.entries.showReinstateModal),
    primaryActionText: `Yes, ${headerAction}`,
    secondaryActionText: 'Cancel',
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    toggleDialog: partial(toggleEntryReinstate, null),
    submitAction: partial(reinstateEntry, projectId),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Confirmation));



// WEBPACK FOOTER //
// ./project/containers/entries/reinstate_modal.js